import { render } from "./Smp.vue?vue&type=template&id=1dd3ee30"
import script from "./Smp.vue?vue&type=script&lang=js"
export * from "./Smp.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__